import { render, staticRenderFns } from "./CommentCardView.vue?vue&type=template&id=f8f82a8e&scoped=true&"
import script from "./CommentCardView.vue?vue&type=script&lang=js&"
export * from "./CommentCardView.vue?vue&type=script&lang=js&"
import style0 from "./CommentCardView.vue?vue&type=style&index=0&id=f8f82a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f82a8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
